//

import { PoolControllerDynamicAbi } from '@shared/Abis'
import { ChainConfiguration } from '@shared/DeploymentConfigTypes'
import { LiquidityAsset } from '@shared/LiquidityAsset'
import { logOT } from '@shared/loggingShared'
import { EthAddr, ProviderReadOnly } from '@shared/SchemaTypes'
import { PoolControllerDynamic } from '@typechain-types/index'
import axios from 'axios'
import { Contract } from 'ethers'

export async function poolDynamicStates(params: {
  poolControllerAddr: EthAddr
  providerReadOnly: ProviderReadOnly
}): Promise<{ depositActive: boolean; withdrawActive: boolean }> {
  logOT.debug('poolDynamicStates start', params.poolControllerAddr, PoolControllerDynamicAbi, params.providerReadOnly)
  const poolDynamicControllerContract = new Contract(
    params.poolControllerAddr,
    PoolControllerDynamicAbi,
    params.providerReadOnly
  ) as unknown as PoolControllerDynamic

  const ds = await poolDynamicControllerContract.depositState()

  const depositActive = ds == 0n
  const ws = await poolDynamicControllerContract.withdrawState()

  const withdrawActive = ws == 0n

  return {
    depositActive,
    withdrawActive,
  }
}

export async function fetchLiquidityAssetsForChainConfig(
  chainConfiguration: ChainConfiguration,
  serverApiBaseUrl: string,
  restAPIKey: string,
  refresh?: boolean
): Promise<LiquidityAsset[]> {
  const response = await axios.get(
    refresh
      ? `${serverApiBaseUrl}/liquidityAssets/${chainConfiguration.chainConfigurationName}?refresh=true`
      : `${serverApiBaseUrl}/liquidityAssets/${chainConfiguration.chainConfigurationName}`,
    {
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': restAPIKey,
      },
    }
  )
  logOT.debug('fetchPoolParticipants response', response.data.liquidityAssets)
  return response.data.liquidityAssets || []
}
